import { createElement } from 'react';
const HtmlTag = ({ html, tag, attrs }) => createElement(tag, Object.assign({ dangerouslySetInnerHTML: { __html: html } }, attrs));
HtmlTag.defaultProps = {
    tag: 'span',
};
export default HtmlTag;
